export default __webpack_public_path__ + "static/media/sarisari-desktop.7680b26f.jpg";